// src/components/layout/MobileBottomNav.tsx
import { Link, useLocation } from 'react-router-dom';
import { Home, Grid3X3, Search, ShoppingCart, User } from 'lucide-react';
import { useCart } from '@/hooks/useCart';
import { useAuth } from '@/hooks/auth';
import { productsPrefetchHandlers } from '@/utils/prefetchProductsRoute';

const MobileBottomNav = () => {
  const location = useLocation();
  const { cartItems } = useCart();
  const { user } = useAuth();

  const isActive = (path: string) =>
    location.pathname === path
      ? 'text-springbok-600'
      : 'text-gray-500';

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-200 md:hidden">
      <div className="flex items-center justify-around h-16">
        <Link to="/" className={`flex flex-col items-center justify-center flex-1 h-full ${isActive('/')}`}>
          <Home size={20} />
          <span className="text-xs mt-1">Home</span>
        </Link>

        <Link to="/products" {...productsPrefetchHandlers} className={`flex flex-col items-center justify-center flex-1 h-full ${isActive('/products')}`}>
          <Grid3X3 size={20} />
          <span className="text-xs mt-1">Shop</span>
        </Link>

        <Link to="/products?focus=search" className={`flex flex-col items-center justify-center flex-1 h-full ${isActive('/products')}`}>
          <Search size={20} />
          <span className="text-xs mt-1">Search</span>
        </Link>

        <Link to="/cart" className={`flex flex-col items-center justify-center flex-1 h-full ${isActive('/cart')} relative`}>
          <div id="mobile-cart-target" className="relative">
            <ShoppingCart size={20} />
            {cartItems?.reduce((sum, item) => sum + (item.quantity || 1), 0) > 0 && (
              <span className="absolute -top-2 -right-2 bg-springbok-600 text-white text-[10px] font-bold rounded-full h-4 w-4 flex items-center justify-center">
                {cartItems.reduce((sum, item) => sum + (item.quantity || 1), 0)}
              </span>
            )}
          </div>
          <span className="text-xs mt-1">Cart</span>
        </Link>

        <Link to={user ? '/account' : '/login'} className={`flex flex-col items-center justify-center flex-1 h-full ${isActive(user ? '/account' : '/login')}`}>
          <User size={20} />
          <span className="text-xs mt-1">{user ? 'Account' : 'Login'}</span>
        </Link>
      </div>
    </nav>
  );
};

export default MobileBottomNav;
